import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { detailsFields as fields } from "./details.const"

const commonAdhRoleConf = {
  [fields.primaryHolder.root]: {
    disabled: true,
  },
  [fields.primaryHolder.phone]: {
    disabled: true,
  },
  [fields.primaryHolder.email]: {
    disabled: true,
  },
  oldHolderRules: {
    allowCreate: false,
    displayOnlyValue: true,
  },
  newHolderRules: {
    allowCreate: false,
    displayOnlyValue: false,
  },
}

export const formRoleConf: RoleStrategy<
  Record<
    string,
    {
      disabled?: boolean
      displayOnlyValue?: boolean
      hideActions?: boolean
    }
  >
> = {
  [ROLES.ADMIN]: {
    [fields.primaryHolder.phone]: {
      disabled: true,
    },
    [fields.primaryHolder.email]: {
      disabled: true,
    },
  },
  [ROLES.ADHERENT_HOLDER]: commonAdhRoleConf,
  [ROLES.ADHERENT_TEAM]: {
    ...commonAdhRoleConf,
    [fields.primaryHolder.root]: {
      ...commonAdhRoleConf[fields.primaryHolder.root],
      hideActions: true,
    },
    oldHolderRules: {
      ...commonAdhRoleConf.oldHolderRules,
      disabled: true,
    },
    newHolderRules: {
      ...commonAdhRoleConf.newHolderRules,
      disabled: true,
    },
    [fields.pharmacy]: {
      disabled: true,
    },
    [fields.address.line1]: {
      disabled: true,
    },
    [fields.address.line2]: {
      disabled: true,
    },
    [fields.address.postalCode]: {
      disabled: true,
    },
    [fields.address.city]: {
      disabled: true,
    },
    [fields.otherHolders]: {
      disabled: true,
    },
    [fields.email]: {
      disabled: true,
    },
    [fields.phone]: {
      disabled: true,
    },
    [fields.mobile]: {
      disabled: true,
    },
    [fields.fax]: {
      disabled: true,
    },
  },
}
